import { useCallback, useRef, useState } from "react";

/**
 * Holds a submit closed from the moment it starts until it settles. The ref blocks a second
 * submit in the same tick; the state is what disables the button.
 */
const useSyncLock = () => {
  const locked = useRef(false);
  const [isSyncing, setIsSyncing] = useState(false);

  const tryLock = useCallback(() => {
    if (locked.current) return false;
    locked.current = true;
    setIsSyncing(true);
    return true;
  }, []);

  const unlock = useCallback(() => {
    locked.current = false;
    setIsSyncing(false);
  }, []);

  return { isSyncing, tryLock, unlock };
};

export default useSyncLock;
